export default __webpack_public_path__ + "static/media/logo.88ef74c2.png";